import Http from './http'

/**
 * Sending health for the shared SES account.
 *
 * Always resolves with a payload: the AWS half can be unavailable (no
 * credential, no permission) while the local attribution still renders, so the
 * card reads `aws_available` rather than treating a partial answer as an error.
 *
 * `fresh` skips the 5-minute server cache — for the refresh button, not for
 * polling: the underlying CloudWatch metrics do not move faster than that and
 * every call is billed.
 */
export const sesHealth = (fresh = false) => Http.get(`/admin/ses-health${fresh ? '?fresh=1' : ''}`)
